export default {
	attributes: {
		restrictContentWidth: false,
		design: 'basic',
		height: 'normal',
		columnBackgroundCustomSizeUnit: '%',
		columnTabletBackgroundCustomSizeUnit: '%',
		columnMobileBackgroundCustomSizeUnit: '%',
		imageSize: 'full',
		imageWidthUnit: '%',
		imageTabletWidthUnit: '%',
		imageMobileWidthUnit: '%',
		imageCollapseOnMobile: true,
		imageCollapseOnMobileHeight: 300,
		uniqueClass: 'ugb-fed2b18',
		hideDesktop: false,
		hideTablet: false,
		hideMobile: false,
		showBlockBackground: false,
		blockBackgroundBackgroundCustomSizeUnit: '%',
		blockBackgroundTabletBackgroundCustomSizeUnit: '%',
		blockBackgroundMobileBackgroundCustomSizeUnit: '%',
		topSeparatorDesign: 'wave-1',
		bottomSeparatorDesign: 'wave-1',
		topSeparatorShadow: true,
		bottomSeparatorShadow: true,
	},
	innerBlocks: [
		{
			clientId: '037996f6-5e74-4eb6-8aad-b5dce1446d50',
			name: 'ugb/text',
			isValid: true,
			originalContent: '<div class="wp-block-ugb-text ugb-text ugb-c5deeb7 ugb-text--design-plain ugb-text--columns-1 ugb-main-block"><div class="ugb-inner-block"><div class="ugb-block-content"><div class="ugb-text__text-wrapper"><div class="ugb-text__text"><p class="ugb-text__text-1">Description for this block. Use this space for describing your block. Any text will do. Description for this block. You can use this space for describing your block.</p></div></div></div></div></div>',
			attributes: {
				design: 'plain',
				columns: 1,
				reverseTitle: false,
				alignment: 'center',
				showColumnRule: false,
				showTitle: false,
				titleLineHeightUnit: 'em',
				titleTabletLineHeightUnit: 'em',
				titleMobileLineHeightUnit: 'em',
				showSubtitle: false,
				subtitleLineHeightUnit: 'em',
				subtitleTabletLineHeightUnit: 'em',
				subtitleMobileLineHeightUnit: 'em',
				subtitleColor: '',
				subtitleOnTop: false,
				text1: 'Description for this block. Use this space for describing your block. Any text will do. Description for this block. You can use this space for describing your block.',
				textLineHeightUnit: 'em',
				textTabletLineHeightUnit: 'em',
				textMobileLineHeightUnit: 'em',
				uniqueClass: 'ugb-c5deeb7',
				hideDesktop: false,
				hideTablet: false,
				hideMobile: false,
				showBlockBackground: false,
				blockBackgroundBackgroundCustomSizeUnit: '%',
				blockBackgroundTabletBackgroundCustomSizeUnit: '%',
				blockBackgroundMobileBackgroundCustomSizeUnit: '%',
				topSeparatorDesign: 'wave-1',
				bottomSeparatorDesign: 'wave-1',
			},
		} ],
}
